import React from 'react';
import { assertExhaustive, assertNotNil } from 'venn-utils';
import type { MultiPortfolioUploaderViewId } from '../types';
import { useMultiPortfolioUploaderState } from './hooks/useMultiPortfolioUploaderState';
import { MultiHistoricalReviewStep } from './MultiHistoricalReviewStep';
import MultiPortfolioConfirmationStep from './MultiPortfolioConfirmationStep';
import MultiPortfolioUploadStep from './MultiPortfolioUploadStep';
import { MultiProFormaReviewStep } from './MultiProFormaReviewStep';

type MultiPortfolioUploaderProps = Readonly<{
  viewId: MultiPortfolioUploaderViewId;
}>;

const MultiPortfolioUploader = ({ viewId }: MultiPortfolioUploaderProps) => {
  const { parsedData, uploadConfirmationData, goToReviewStep, goBackToUploadStep, goToUploadConfirmation } =
    useMultiPortfolioUploaderState();

  switch (viewId) {
    case 'UPLOAD_PORTFOLIO':
      return <MultiPortfolioUploadStep goToReviewStep={goToReviewStep} />;
    case 'REVIEW_PRO_FORMA_PORTFOLIO':
      return (
        <MultiProFormaReviewStep
          parsedData={assertNotNil(parsedData)}
          goBackToUploadStep={goBackToUploadStep}
          goToUploadConfirmation={goToUploadConfirmation}
        />
      );
    case 'REVIEW_HISTORICAL_PORTFOLIO':
      return (
        <MultiHistoricalReviewStep
          parsedData={assertNotNil(parsedData)}
          goBackToUploadStep={goBackToUploadStep}
          goToUploadConfirmation={goToUploadConfirmation}
        />
      );
    case 'PORTFOLIO_UPLOAD_CONFIRMATION':
      return <MultiPortfolioConfirmationStep uploadConfirmationData={assertNotNil(uploadConfirmationData)} />;
    default:
      throw assertExhaustive(viewId);
  }
};

export default MultiPortfolioUploader;
